import { useState, useEffect, useCallback } from 'react';
import { Project } from '@brg/api';
import { BookmarkAPI } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';

interface UseProjectCardBookmarkProps {
  project?: Project;
  onUpdate?: () => void;
}

export const useProjectCardBookmark = ({ project, onUpdate }: UseProjectCardBookmarkProps) => {
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const toasts = useToasts();
  const { t } = useTranslation();

  useEffect(() => {
    if (!project) return;
    //@ts-ignore
    setIsBookmarked(project.isBookmark);
  }, [project]);

  const handleBookmarkClick = useCallback(() => {
    if (!project) return;
    const method = isBookmarked ? 'RemoveBookmark' : 'Bookmark';
    BookmarkAPI[method]({ entityId: project?.projectId, entityType: 'project' })
      .then(() => {
        setIsBookmarked(!isBookmarked);
        onUpdate && onUpdate();
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      });
  }, [t, project, toasts, isBookmarked, onUpdate]);

  return {
    isBookmarked,
    handleBookmarkClick,
  };
};
import { useState, useEffect, useCallback } from 'react';
import { Project } from '@brg/api';
import { BookmarkAPI } from '@brg/api';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';

interface UseProjectCardBookmarkProps {
  project?: Project;
  onUpdate?: () => void;
}

export const useProjectCardBookmark = ({ project, onUpdate }: UseProjectCardBookmarkProps) => {
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const toasts = useToasts();
  const { t } = useTranslation();

  useEffect(() => {
    if (!project) return;
    //@ts-ignore
    setIsBookmarked(project.isBookmark);
  }, [project]);

  const handleBookmarkClick = useCallback(() => {
    if (!project) return;
    const method = isBookmarked ? 'RemoveBookmark' : 'Bookmark';
    BookmarkAPI[method]({ entityId: project?.projectId, entityType: 'project' })
      .then(() => {
        setIsBookmarked(!isBookmarked);
        onUpdate && onUpdate();
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      });
  }, [t, project, toasts, isBookmarked, onUpdate]);

  return {
    isBookmarked,
    handleBookmarkClick,
  };
};
